import React, { useState, useRef } from 'react';
import { Upload, FileText } from 'lucide-react';
interface FileUploadProps {
  onFileSelect: (file: File) => void;
  label?: string;
  accept?: string;
}
export function FileUpload({
  onFileSelect,
  label = 'Upload File',
  accept
}: FileUploadProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      onFileSelect(file);
    }
  };
  const handleDragOver = (event: React.DragEvent) => {
    event.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault();
    setIsDragging(false);
    const file = event.dataTransfer.files?.[0];
    if (file) {
      setSelectedFile(file);
      onFileSelect(file);
    }
  };
  const onButtonClick = () => {
    fileInputRef.current?.click();
  };
  return <div className="w-full" data-id="element-166">
      <div className={`relative border-2 border-dashed rounded-lg p-6 transition-colors ${isDragging ? 'border-teal-500 bg-teal-500/10' : selectedFile ? 'border-teal-500/50 bg-teal-500/5' : 'border-slate-700 hover:border-slate-600'}`} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} data-id="element-167">
        <input ref={fileInputRef} type="file" onChange={handleFileChange} accept={accept} className="hidden" data-id="element-168" />

        {selectedFile ? <div className="flex items-center justify-center space-x-3" data-id="element-169">
            <FileText className="h-6 w-6 text-teal-500 flex-shrink-0" data-id="element-170" />
            <div className="flex-1 min-w-0" data-id="element-171">
              <p className="text-sm font-medium text-white truncate" data-id="element-172">
                {selectedFile.name}
              </p>
              <p className="text-xs text-slate-400" data-id="element-173">
                {(selectedFile.size / 1024).toFixed(1)} KB
              </p>
            </div>
            <button type="button" onClick={onButtonClick} className="text-xs text-teal-400 hover:text-teal-300 font-medium" data-id="element-174">
              Change
            </button>
          </div> : <div className="text-center" data-id="element-175">
            <Upload className="mx-auto h-8 w-8 text-slate-500" data-id="element-176" />
            <p className="mt-2 text-sm text-slate-400" data-id="element-177">{label}</p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-178">or drag and drop</p>
          </div>}

        {!selectedFile && <button type="button" onClick={onButtonClick} className="absolute inset-0 w-full h-full cursor-pointer focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 focus:ring-offset-navy-900 rounded-lg" aria-label={label} data-id="element-179" />}
      </div>
    </div>;
}